import React, { useState, useEffect } from "react"
import { getCalcoloAutomatico, getCalcoloAutomaticoExtended, getTipiVeicoli } from "../../services/endpoints";
import { showProgress } from "../../utils/elements";
import {
  Container,
  Alert,
  Col,
  Row,
  FormGroup,
  Select,
  Button,
} from 'design-react-kit';
import SibaMostraRiepilogo from "./stepverifica/SibaMostraRiepilogo";
import SibaMostraAlternative from "./stepverifica/SibaMostraAlternative"
import SibaMostraSottoAlternative from "./stepverifica/SibaMostraSottoAlternative"
import SibaMostraCalcoloFisso from "./stepverifica/SibaMostraCalcoloFisso";
import SibaInputScadenzaValidita from "./stepverifica/SibaInputScadenzaValidita"
import { formatScadenza, getMeseFromNumber } from "../../utils/format";
import * as Constants from "../../utils/constants"

export const SibaVerificaOperazione = ({ _cf, _targa, _handleDataLoaded, _handleBack, _handleNext }) => {

  const [calcolo, setCalcolo] = useState('');
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [scenario, setScenario] = useState('');
  const [choice, setChoice] = useState('');
  const [scadenzaForzata, setScadenzaForzata] = useState('');
  const [validitaForzata, setValiditaForzata] = useState('12');
  const [importoForzato, setImportoForzato] = useState(0);
  const [nonPagabile, setNonPagabile] = useState(false);
  const [messaggioErrore, setMessaggioErrore] = useState('');

  const [isAgevolazione, setAgevolazione] = useState(false);
  const [tipiVeicoli, setTipiVeicoli] = useState([])
  const [tipoVeicolo, setTipoVeicolo] = useState(undefined)


const loadCalcolo = async (codiceFiscale, targa) => {
      const responseCalcoloTassa = await getCalcoloAutomatico(codiceFiscale, targa, tipoVeicolo);
      console.log('responseCalcoloTassa', responseCalcoloTassa)
      if (responseCalcoloTassa === undefined) {
        console.log('Calcolo fallito per veicolo %s', targa)
        setLoading(false)
        return
      }

      if (responseCalcoloTassa && responseCalcoloTassa.detail) {
        if (responseCalcoloTassa.detail === Constants.ESITO_CALCOLO_NO_MATCH || responseCalcoloTassa.detail === Constants.ESITO_CALCOLO_NO_MATCH_ESE|| responseCalcoloTassa.detail === Constants.ESITO_CALCOLO_NON_PAGABILE) {
          setScenario(responseCalcoloTassa.detail)
          _handleDataLoaded({ "datiPagamento": responseCalcoloTassa, "scenarioAlternativo": scenario });
        } else if (responseCalcoloTassa.detail === Constants.ESITO_CALCOLO_NO_MATCH_CF){
          setScenario(responseCalcoloTassa.detail)
          _handleDataLoaded({ "datiPagamento": responseCalcoloTassa, "scenarioAlternativo": scenario });
        } else if(responseCalcoloTassa.detail === Constants.ESITO_CALCOLO_NO_VEICOLO_MATCH){
           setScenario(responseCalcoloTassa.detail)
           const listaTipiVeicoli = await getTipiVeicoli();
           setTipiVeicoli(listaTipiVeicoli)
          _handleDataLoaded({ "datiPagamento": responseCalcoloTassa, "scenarioAlternativo": scenario });
        } else {
          // risposta con errore
          console.log('responseCalcoloTassa.detail', responseCalcoloTassa.detail)
          setError(responseCalcoloTassa.detail);
        }
      } else {
        //Se passo di qui, il pagamento è sempre non auth, quindi devo evitare idVeicolo e forzare
        const calcoloEsteso = appendImportoForzato(responseCalcoloTassa);
        setCalcolo(calcoloEsteso)
        setScenario(Constants.ESITO_CALCOLO_PAGABILE);
        _handleDataLoaded({ "datiPagamento": calcoloEsteso, "scenarioAlternativo": scenario });
      }

      setLoading(false);
    }


  useEffect(() => {
    loadCalcolo(_cf, _targa);
  }, []);

  useEffect(() => {
    if (scadenzaForzata && importoForzato && validitaForzata) {
      const calcoloForzato = buildCalcoloForzato();
      _handleDataLoaded({ "datiPagamento": calcoloForzato, "scenarioAlternativo": scenario });
      setCalcolo(calcoloForzato)
    }
  }, [importoForzato, scadenzaForzata, validitaForzata])

  useEffect(() => {
    const loadCalcoloNonPagabile = async (codiceFiscale, targa) => {
      setLoading(true);
      const scadenzaAAAAMM = formatScadenza(scadenzaForzata);
      const responseCalcoloTassaNonPagabile = await getCalcoloAutomaticoExtended(codiceFiscale, targa, scadenzaAAAAMM, validitaForzata);
      console.log('responseCalcoloTassaNonPagabile', responseCalcoloTassaNonPagabile)
      if (responseCalcoloTassaNonPagabile === undefined) {
        console.log('Calcolo fallito per scadenza %s e validità %s', scadenzaAAAAMM, validitaForzata)
        setLoading(false)
        return
      }

      if (responseCalcoloTassaNonPagabile.status !== undefined) {
        // risposta con errore
        setMessaggioErrore('Calcolo della tassa non effettuabile');
        setScenario(Constants.ESITO_CALCOLO_ERRORE);
      } else {
        const calcoloEsteso = appendImportoForzato(responseCalcoloTassaNonPagabile);
        _handleDataLoaded({ "datiPagamento": calcoloEsteso, "scenarioAlternativo": scenario });
        setCalcolo(calcoloEsteso);
        setScenario(Constants.ESITO_CALCOLO_PAGABILE);
        setNonPagabile(false)
      }
      setLoading(false)
    }

    if (scadenzaForzata && validitaForzata) {
      loadCalcoloNonPagabile(_cf, _targa);
    }
  }, [nonPagabile])

  const appendImportoForzato = (calcolo) => {
    return (
      {
        "dataScadenza": calcolo.dataScadenza,
        "validita": calcolo.validita,
        "importo": calcolo.importo,
        "importoForzato": true,
        "idVeicolo" : calcolo.idVeicolo,
        "tipoVeicolo": calcolo.codiceVeicolo
      }
    )
  }

  const handleChoice = (choice) => { console.log(choice); setChoice(choice) }
  const handleImportoChange = (importo) => { console.log('handleImportoChange', importo); setImportoForzato(importo) }
  const handleScadenzaChange = (scadenza) => { console.log('handleScadenzaChange', scadenza); setScadenzaForzata(scadenza) }
  const handleValiditaChange = (validita) => { console.log('handleValiditaChange', validita); setValiditaForzata(validita) }
  const handleNonPagabileChange = () => { console.log('chiamata a handleNonPagabileChange'); setNonPagabile(true) }
  const handleCambiaScadenza = () => { console.log(' cambio scadenza ' + scenario); setScenario('NON_PAGABILE') }
  const handleBackSottoAlternative = () => { console.log(' choice ' + choice); setChoice('altri_casi') }

  const buildCalcoloForzato = () => {
    console.log('buildCalcoloForzato')
    console.log('scadenzaForzata', scadenzaForzata)
    const scadenzaAAAAMM = formatScadenza(scadenzaForzata);
    const idMeseNum = scadenzaAAAAMM.substring(4, 6);
    const idAnnoNum = scadenzaAAAAMM.substring(0, 4)
    const idMeseStr = getMeseFromNumber(idMeseNum);
    return (
      {
        "dataScadenza": {
          "mese": {
            "idDecodifica": {
              "id": idMeseNum
            },
            "descrizione": idMeseStr,
            "codice": idMeseStr.substring(0, 3)
          },
          "anno": idAnnoNum
        },
        "validita": choice === Constants.ALTRI_CASI_VEICOLI_STORICI ? 36 : validitaForzata,
        "importo": {
          "totale": {
            "importo": importoForzato,
            "divisa": {
              "idDecodifica": {
                "id": 1
              },
              "descrizione": "Euro",
              "codice": "EUR"
            }
          },
        },
        "importoForzato": true,
      }
    )
  }

  const renderScenario = () => {
    console.log("renderScenario: scenario=", scenario)
    switch (scenario) {
      case Constants.ESITO_CALCOLO_PAGABILE: {
        return (
          <SibaMostraRiepilogo
            _targa={_targa}
            _calcolo={calcolo}
            _handleCambiaScadenza={handleCambiaScadenza}
            _handleBack={_handleBack}
            _handleNext={_handleNext}
          />
        );
      }
      case Constants.ESITO_CALCOLO_NO_MATCH: {
        console.log("renderScenario: calcolo=", calcolo)
        if(isAgevolazione == true){
          setAgevolazione(false);
        }
        if (choice && choice !== '') {
          console.log("renderScenario: choice=", choice)
          return renderChoice();
        }

        return (
          <SibaMostraAlternative
            codiceFiscale={_cf}
            targa={_targa}
            handleChoice={handleChoice}
            handleBack={_handleBack}
          />
        );
      }
      case Constants.ESITO_CALCOLO_NO_MATCH_ESE: {
        if(isAgevolazione == false){
          setAgevolazione(true);
        }
        console.log("renderScenario: calcolo=", calcolo)
        if (choice && choice !== '') {
          console.log("renderScenario: choice=", choice)
          return renderChoice();
        }

        return (
          <SibaMostraAlternative
            codiceFiscale={_cf}
            targa={_targa}
            handleChoice={handleChoice}
            handleBack={_handleBack}
          />
        );
      }
      case Constants.ESITO_CALCOLO_NON_PAGABILE: {
        console.log("renderScenario: calcolo=", calcolo)
        if (choice && choice !== '') {
          console.log("renderScenario: choice=", choice)
          return renderChoice();
        }

        return (
          <SibaInputScadenzaValidita
            __handleScadenzaChange={handleScadenzaChange}
            __handleValiditaChange={handleValiditaChange}
            handleNonPagabileChange={handleNonPagabileChange}
          />
        );
      }
      case Constants.ESITO_CALCOLO_NO_VEICOLO_MATCH:
        return(
          <>
            <h3>Ulteriori dati necessari</h3> 
            <Alert color="danger">Non e' posssibile identificare univocamente il veicolo. Inserire il tipo veicolo</Alert>
            <Container className="px-2 my-2" id="scadenzaVeicolo" tag="section" >
              <Container className="my-4" id="scadenzaVeicolo1" tag="section" >
                 <table className="table table-striped table-sm">
                    <tbody>
                          <tr>
                            <th>Codice Fiscale:</th>
                            <td>{_cf}</td>
                          </tr>
                          <tr>
                            <th>Targa:</th>
                            <td>{_targa}</td>
                          </tr>
                          <tr>
                            <th>Tipo veicolo</th>
                            <td>
                                <Select id="tipoVeicolo" 
                                        label="Tipo Veicolo" 
                                        placeholder="Tipo veicolo" 
                                        value={tipoVeicolo?.value ? tipoVeicolo : ""} 
                                        options={tipiVeicoli} 
                                        onChange={(e) =>{ setTipoVeicolo(e )} } 
                                        required/>

                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>
                                <Button className="btn btn-primary" color="primary" onClick={() => loadCalcolo(_cf,_targa,tipoVeicolo)}>
                                  Ricalcola
                                </Button>
                            </td>
                          </tr>
                    </tbody>
                    
                 </table>
              </Container>
            </Container>  
          </>
        )

      case Constants.ESITO_CALCOLO_ERRORE:
        return (
          <Alert color="danger">{messaggioErrore}</Alert>
        )
      case Constants.ESITO_CALCOLO_NO_MATCH_CF:
          return (
            <Alert color="danger">Il veicolo non è associabile al proprietario inserito</Alert>
          )
      default:
        return (
          <Alert color="danger">Unknown step for {scenario}!</Alert>
        )
    };
  };

  const renderChoice = () => {
    console.log("renderChoice: choice=", choice)
    switch (choice) {
      case Constants.ALTRI_CASI_VEICOLI_STORICI:
      case Constants.ALTRI_CASI_AFI:
      case Constants.ALTRI_CASI_ESCURSIONISTI_ESTERI:
      case Constants.CRISI_FALLIMENTO:
      case Constants.ALTRI_CASI_ALTRO: {
        const calcoloForzato = buildCalcoloForzato();
        return (
          <SibaMostraRiepilogo
            _choice={choice}
            _targa={_targa}
            _calcolo={calcoloForzato}
            //_handleCambiaScadenza={handleBackSottoAlternative}
            _handleBack={_handleBack}
            _handleNext={_handleNext}
          />
        );
      }
      case Constants.TIPO_VEICOLO_CICLOMOTORE:
      case Constants.TIPO_VEICOLO_QUADRICICLO_LEGGERO:
      case Constants.TIPO_VEICOLO_TARGA_PROVA_AUTO:
      case Constants.TIPO_VEICOLO_TARGA_PROVA_MOTO:
      case Constants.TIPO_VEICOLO_TARGA_PROVA_CICLO:
      case Constants.TIPO_VEICOLO_TARGA_PROVA_RIMORCHIO: {
        return (
          <SibaMostraCalcoloFisso
            targa={_targa}
            tipoVeicolo={choice} //convertire i tipo lato java backend
            handleDataLoaded={_handleDataLoaded}
            handleBack={_handleBack}
            handleNext={_handleNext}
          />
        );
      }
      case Constants.TIPO_VEICOLO_ALTRI_CASI: {
        return (
          <SibaMostraSottoAlternative
            handleChoice={handleChoice}
            handleImportoChange={handleImportoChange}
            handleScadenzaChange={handleScadenzaChange}
            handleValiditaChange={handleValiditaChange}
            handleBack={_handleBack}
            isAgevolazione={isAgevolazione}
          />
        );
      }
      default:
        return (
          <Alert color="danger">Unknown step for {choice}!</Alert>
        )
    }
  }

  const addContainer = (fragment) => {
    return (
      <Container className="px-2 my-2" id="verificaOperazione" tag="section">
        {fragment}
      </Container>
    );
  }

  //START RENDERING
  if (isLoading) { return showProgress() }
  if (error) { throw new Error(error) } //TODO aggiungo msg di info dinamico

  return addContainer(renderScenario());
}

export default SibaVerificaOperazione;